<!-- eslint-disable -->
<template lang="pug">
  .settings(v-if='settings')
    span
      | {{ 'Количество планет' }}:
      | {{ settings.amountOfPlanets }}
    br
    span
      | {{ 'Тип примеров' }}:
      | {{ typeName }}
    br
    span
      | {{ 'Длительность игры' }}:
      | {{ settings.gameDuration.label }}
    br
    template(v-if="settings.complication.selected" )
        span
          | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleComplication') }}:
          | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        br
        span
          | {{ 'Количество шагов' }}:
          | {{ settings.complication.steps }}
        br
    template(v-else)
        span
          | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleComplication') }}:
          | {{ $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
        br
    template(v-if="settings.distraction")
        span
          | {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}:
          | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        br
    template(v-else)
        span
          | {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}:
          | {{ $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
        br
    template(v-if="settings.tip")
        span
          | {{ 'Подсказка' }}:
          | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        br
    template(v-else)
        span
          | {{ 'Подсказка' }}:
          | {{ $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
        br
    slot

</template>

<script>
/*eslint-disable*/
import TrainerUtilities from '../../../utils/trainer/trainer';
import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

export default {
  mixins: [TrainerUtilities, gamePreviewMixin],
  props: {
    game: Object,
    parameters: Object,
    userId: Number,
    parametersFrom: {
      type: String,
      default: 'homework'
    }
  },
  computed: {
      typeName() {
          switch (this.settings.type.value) {
              case 'digits':
                  return 'Цифры';
              case 'colors':
                  return 'Цвета';
              case 'mixed':
                  return 'Смешанный';
              default:
                  return '';
          }
      },
  }
}
</script>
